import React from 'react'

const MessageReceivedIcon = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52827 4.02851C3.78862 3.76816 4.21073 3.76816 4.47108 4.02851L7.13775 6.69518C7.3981 6.95553 7.3981 7.37764 7.13775 7.63799C6.8774 7.89834 6.45529 7.89834 6.19494 7.63799L3.52827 4.97132C3.26792 4.71097 3.26792 4.28886 3.52827 4.02851Z" fill="#7A7A7A" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4714 1.36201C12.7318 1.62236 12.7318 2.04447 12.4714 2.30482L7.13807 7.63815C6.87772 7.8985 6.45561 7.8985 6.19526 7.63815C5.93491 7.3778 5.93491 6.95569 6.19526 6.69534L11.5286 1.36201C11.7889 1.10166 12.2111 1.10166 12.4714 1.36201Z" fill="#7A7A7A" />
        </svg>
    )
}

export default MessageReceivedIcon